import React from "react";
import PropTypes from "prop-types";
import {
  Videocam,
  Email,
  Phone,
  Store,
  Computer,
  DirectionsWalk
} from "@mui/icons-material";
import { validateOrderShopTypes } from "../../constants";
import { Tooltip } from "../Tooltip";
import makeStyles from "@mui/styles/makeStyles";
import { Typography } from "@mui/material";

const useStyles = makeStyles(theme => ({
  icon: {
    verticalAlign: "middle",
    "& > svg": {
      overflow: "visible"
    }
  }
}));

function ValidateOrderTypeIcon(props) {
  const classes = useStyles();
  const { size, color } = props;
  const iconProps = {
    fontSize: size,
    color,
    className: classes.icon
  };

  function createValidateOrderTypeIconWithTooltip(activityType) {
    return (
      <Tooltip
        title={
          <Typography color="textSecondary" variant="inherit" noWrap>
            {activityType}
          </Typography>
        }
      >
        {createValidateOrderTypeIcon(activityType)}
      </Tooltip>
    );
  }

  function createValidateOrderTypeIcon(activityType) {
    const activity = activityType.toLowerCase();
    switch (activity) {
      case validateOrderShopTypes.internet.toLowerCase():
        return <Email {...iconProps} />;
      case validateOrderShopTypes.phoneRecodered.toLowerCase():
      case validateOrderShopTypes.phoneNonRecorded.toLowerCase():
        return <Phone {...iconProps} />;
      case validateOrderShopTypes.onsiteRecordedAudio.toLowerCase():
      case validateOrderShopTypes.onsiteNonRecordedAudio.toLowerCase():
        return <Store {...iconProps} />;
      case validateOrderShopTypes.videoShop.toLowerCase():
      case validateOrderShopTypes.video.toLowerCase():
        return <Videocam {...iconProps} />;
      case validateOrderShopTypes.virtualShopAudioRecorded.toLowerCase():
      case validateOrderShopTypes.virtualShopAudioVideoRecorded.toLowerCase():
        return <Computer {...iconProps} />;
      case validateOrderShopTypes.selfGuidedTourAudioRecorded.toLowerCase():
      case validateOrderShopTypes.selfGuidedTourAudioVideoRecorded.toLowerCase():
      case validateOrderShopTypes.selfGuidedTourNonRecorded.toLowerCase():
        return <DirectionsWalk {...iconProps} />;
      default:
        return <Computer {...iconProps} />;
    }
  }

  return props.type ? createValidateOrderTypeIconWithTooltip(props.type) : null;
}

export default ValidateOrderTypeIcon;

ValidateOrderTypeIcon.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string
};

ValidateOrderTypeIcon.defaultProps = {
  fontSize: "default",
  color: "action"
};
